import { inject, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { EMPTY, Observable, catchError, throwError } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { FreeformApiService } from "../services/freeform.api.service";
import { PollApiService } from "../services/poll.api.service";
import { Interactive } from "../models/interactive.model";
import { isFreeformId, isPollId } from "../../shared/models/entity.model";
import { SnackbarService } from "../../components/snackbar/snackbar.service";

export function injectRouteInteractive(): Signal<Interactive | undefined> {
    const freeformApi = inject(FreeformApiService);
    const pollApi = inject(PollApiService);
    const snackbarService = inject(SnackbarService);
    const interactiveId = inject(ActivatedRoute).snapshot.paramMap.get("interactiveId") ?? "";

    let fetch$: Observable<Interactive>;
    if (isPollId(interactiveId)) {
        fetch$ = pollApi.get(interactiveId);
    } else if (isFreeformId(interactiveId)) {
        fetch$ = freeformApi.get(interactiveId);
    } else {
        fetch$ = throwError(() => new Error(`Unknown interactive id prefix: ${interactiveId}`));
    }

    return toSignal(
        fetch$.pipe(
            catchError(() => {
                snackbarService.show("We couldn't load the interactive. Try again.", "error");
                return EMPTY;
            })
        )
    );
}
